module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_3.9f5de8f6.png";